module.exports = __webpack_public_path__ + "static/media/WINGS.423fe0a0.svg";